import { render, staticRenderFns } from "./CrisisManager.vue?vue&type=template&id=9c21b13e&scoped=true"
import script from "./CrisisManager.vue?vue&type=script&lang=js"
export * from "./CrisisManager.vue?vue&type=script&lang=js"
import style0 from "./CrisisManager.vue?vue&type=style&index=0&id=9c21b13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c21b13e",
  null
  
)

export default component.exports